"use client"
import { StickerType, stickerImages, StickerColor } from "igualigual-ds"

export const getColorOptionToSticker = (type: StickerType) => {
    return Object.keys(stickerImages[type]) as StickerColor<typeof type>[]
}


